import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as model from '../../../models/InterviewsModel';
import { apiError } from '../../../helpers/ErrorHelper';
import { useAuth } from '../../../context/AuthContext';
import { useNotificationCount } from '../../../context/NotificationCountContext';
import { DatePicker, MyReactSelect, MySelect, MyTimePicker, Text, TextArea } from '../../inputs/inputs';
import { formatDataBeforeDisplay, formatDataBeforeSend, quickAddClient } from '../../../helpers/GeneralHelper';
import { getData as getClients } from '../../../models/ClientsModel';
import { getData as getRequirements } from '../../../models/RequirementsModel';
import { getData as getCandidates } from '../../../models/CandidatesModel';
import * as interviewStatusModel from '../../../models/InterviewStatusModel';
import * as interviewRoundsModel from '../../../models/InterviewRoundsModel';
import { QuickAdd } from '../../modals/QuickAdd';
import AdminLayout from '../../layout/AdminLayout';
import { Helmet } from 'react-helmet';
import PageHeader from '../../common/PageHeader';
import { checkPermission } from "../../../helpers/GeneralHelper";
import WorkflowHelpBanner from "../../common/WorkflowHelpBanner";
import HelpTooltip from "../../common/HelpTooltip";
import { findOnboardByInterviewId, findCandidateById } from "../../../helpers/PipelineFilterHelper";
import {
  INTERVIEW_PIPELINE_RULES,
  validatePipelineForm,
} from "../../../helpers/PipelineFormValidationHelper";
import * as candidateStatusModel from "../../../models/CandidateStatusModel";
import StatusSuggestionModal from "../../common/StatusSuggestionModal";
import {
  mapCandidateStatusOptions,
  resolveInterviewStatusSuggestion,
} from "../../../helpers/StatusAutomationHelper";

export const InterviewFormNew = () => {

  const location = useLocation();
  const isEdit = location.pathname.slice(location.pathname.lastIndexOf("/") + 1, location.pathname.length) == 'edit';
  const isView = location.pathname.slice(location.pathname.lastIndexOf("/") + 1, location.pathname.length) == 'view';
  const module = location.state?.module;
  const data = location.state?.data;
  const prefill = location.state?.prefill;
  const baseURL = process.env.REACT_APP_BASE_URL;

  const inputFields = {
    interview_client_id: '',
    interview_requirement_id: '',
    interview_candidate_id: '',
    interview_round_id: '',
    interview_date: '',
    interview_time: '',
    interview_mode: '',
    interview_status_id: '',
    interview_remarks: '',
    interview_no_show: 0,
  }
  const formatOptions = [
    {
      type: 'react-select',
      column: 'interview_client_id',
      labelColumn: 'client_name'
    },
    {
      type: 'react-select',
      column: 'interview_requirement_id',
      labelColumn: 'requirement_name'
    },
    {
      type: 'react-select',
      column: 'interview_candidate_id',
      labelColumn: 'candidate_name'
    },
    {
      type: 'react-select',
      column: 'interview_round_id',
      labelColumn: 'interview_round_name'
    },
    {
      type: 'react-select',
      column: 'interview_status_id',
      labelColumn: 'status_name'
    },
    {
      type: 'react-datepicker',
      column: 'interview_date',
    },
    {
      type: 'react-timepicker',
      column: 'interview_time',
    },
  ];

  const { notificationCount, setNotificationCount } = useNotificationCount();

  const navigate = useNavigate(); 

  const { state } = useAuth();
  let user_data = state.user_data;
  
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  
  const [id, setId] = useState('');
  const [fields, setFields] = useState(inputFields);

  const [quickModals, setQuickModals] = useState({ clients: false });

  const closeModal = () =>{
    setId('');
    setFields(inputFields);
    setErrors({});
  }

  const optionsModeOfInterviews = [
    {value: 'F2F', label: 'F2F' },
    {value: 'Virtual', label: 'Virtual' },
  ];

  const [clients, setClients] = useState([]);
  const [requirements, setRequirements] = useState([]);
  const [allRequirements, setAllRequirements] = useState([]);
  const [candidates, setCandidates] = useState([]);
  const [rounds, setRounds] = useState([]);
  const [interviewStatus, setInterviewStatus] = useState([]);
  const [isNoShowFromData, setIsNoShowFromData] = useState(false);
  const [recruiterName, setRecruiterName] = useState('');
  const [prefillApplied, setPrefillApplied] = useState(false);
  const [linkedOnboard, setLinkedOnboard] = useState(null);
  const [candidateStatusOptions, setCandidateStatusOptions] = useState([]);
  const [statusSuggestion, setStatusSuggestion] = useState(null);
  const [showStatusSuggestion, setShowStatusSuggestion] = useState(false);
  const pendingAfterSuggestion = useRef(null);
  const fetchClients = async (candidate_id = '') => {
    try {
      const result = await getClients({user_token: user_data.user_token, page: 1, limit: -1});//, candidate_id:candidate_id
      if (! result) return;

      const clientOptions = result.clients.map(client => ({
        value: client._client_id,
        label: client.client_name
      }));

      setClients(clientOptions);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchStatus = async() => {
    try {
      let apiParam = {user_token: user_data.user_token, page: 1, limit: -1};
      const response = await interviewStatusModel.getData(apiParam);

      if (typeof response != typeof undefined) {
        const options = response.interview_status.map(ele => ({
          value: ele._status_id,
          label: ele.status_name
        }));

        setInterviewStatus(options);
      }
    } catch (error) {
      console.error(error);
    }
  }

  const fetchRounds = async() => {
    try {
      let apiParam = {user_token: user_data.user_token, page: 1, limit: -1};
      const response = await interviewRoundsModel.getData(apiParam);

      if (typeof response != typeof undefined) {
        const options = response.interview_rounds.map(ele => ({
          value: ele._interview_round_id,
          label: ele.interview_round_name
        }));

        setRounds(options);
      }
    } catch (error) {
      console.error(error);
    }
  }
  useEffect(() => {
    fetchClients();
    fetchStatus();
    fetchRounds();
    fetchCandidates();
    fetchRequirements();

    const fetchCandidateStatuses = async () => {
      try {
        const response = await candidateStatusModel.getData({
          user_token: user_data.user_token,
          page: 1,
          limit: -1,
        });
        if (response?.candidate_status) {
          setCandidateStatusOptions(mapCandidateStatusOptions(response.candidate_status));
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchCandidateStatuses();
  }, []);

  const [loadingRequirements, setLoadingRequirements] = useState(false);
  const fetchRequirements = async (candidate_id= null) => {
    setLoadingRequirements(true);
    try {
      const apiParam = {
        user_token: user_data.user_token,
        page: 1,
        limit: -1,
        
      };

      const response = await getRequirements(apiParam);
      if (response?.requirements) {
        const options = response.requirements.map(item => ({
          value: item._requirement_id,
          label: item.requirement_name,
          client_id: item.requirement_client_id, // needed for local filter
        }));

        setAllRequirements(options);
        setRequirements(options);
      }
    } catch (error) {
      console.error(error);
    }
    setLoadingRequirements(false);
  };

  const [loadingCandidates, setLoadingCandidates] = useState(false);

  const fetchCandidates = async() => {
    var interview_requirement_id = '';
    if (fields.interview_requirement_id) {
      interview_requirement_id = fields.interview_requirement_id.value;
    }
    setLoadingCandidates(true);

    try {
      let apiParam = {user_token: user_data.user_token, 'candidate_requirement_id': interview_requirement_id, page: 1, limit: -1, include_inactive_mappings: 1};//, candidate_id:candidate_id
      const response = await getCandidates(apiParam);

      if (typeof response != typeof undefined) {
        let options = [];
        let flag = false;
        response.candidates.forEach(function(item) {
          if (fields.interview_candidate_id == item._candidate_id || fields.interview_candidate_id?.value == item._candidate_id) {
            flag = true;
          }
          options.push({
            value: item._candidate_id,
            label: item.candidate_firstname + ' ' + item.candidate_lastname + ' ( '+item.client_name + '- ' + item.requirement_name + ' )',
            recruiterName: item.recruiter_name,
            clientID : item.candidate_client_id,
            client_name : item.client_name,
            requirementID : item.candidate_requirement_id,
            requirement_name : item.requirement_name,
          });
        });
        if (! flag) {
          fields.interview_candidate_id = '';
        }
        setCandidates(options);
      }
    } catch (error) {
      console.error(error);
    }
    setLoadingCandidates(false);
  }

  useEffect(() => {
    // This effect will be called whenever data changes
    if (data) {
      console.log('data => ',data);
      const formatted = formatDataBeforeDisplay(data, formatOptions);
      
      // Ensure interview_no_show comes directly from raw data, not formatted one
      if (typeof data.interview_no_show !== 'undefined') {
        formatted.interview_no_show = Number(data.interview_no_show); // force 0 or 1
      } else {
        formatted.interview_no_show = 0;
      }
      setId(data[module.primaryCol]);
      setFields(formatted);
      setIsNoShowFromData(formatted.interview_no_show === 1);
      setRecruiterName(data.recruiter_name || '');
      setErrors({});
    }
  }, [data]);

  useEffect(() => {
    if (!data?._interview_id || !user_data?.user_token) {
      setLinkedOnboard(null);
      return;
    }

    let cancelled = false;

    const loadLinkedOnboard = async () => {
      try {
        const onboard = await findOnboardByInterviewId(
          user_data.user_token,
          data._interview_id
        );
        if (!cancelled) {
          setLinkedOnboard(onboard);
        }
      } catch (error) {
        console.error(error);
      }
    };

    loadLinkedOnboard();
    return () => {
      cancelled = true;
    };
  }, [data?._interview_id, user_data?.user_token]);

  const candidateChange = async(cand_obj) => {
    //console.log(value);
    if(cand_obj.value){
      console.log(cand_obj.value);
      //fetchClients(cand_obj.value);
      //fetchRequirements(cand_obj.value);
      setRecruiterName(cand_obj.recruiterName);
      // Filter clients — only keep the one related to this candidate
    const filteredClients = clients.filter(
      (cli) => cli.value === cand_obj.clientID
    );
    setClients(filteredClients);

    // Filter requirements — only keep the one related to this candidate
    const filteredRequirements = allRequirements.filter(
      (req) => req.value === cand_obj.requirementID
    );
    setRequirements(filteredRequirements);
      setFields(prev => ({
        ...prev,
        
        // prefill client and requirement IDs
        interview_client_id: cand_obj.clientID 
          ? { value: cand_obj.clientID, label: cand_obj.client_name }
          : '',
        interview_requirement_id: cand_obj.requirementID
          ? { value: cand_obj.requirementID, label: cand_obj.requirement_name }
          : '',
      }));
      console.log(cand_obj.recruiterName);
    }
  }

  useEffect(() => {
    if (data || prefillApplied || !prefill?.candidateId || !candidates.length) return;
    const cand = candidates.find(
      (c) => String(c.value) === String(prefill.candidateId)
    );
    if (cand) {
      setFields((prev) => ({ ...prev, interview_candidate_id: cand }));
      candidateChange(cand);
      setPrefillApplied(true);
    }
  }, [candidates, prefill, data, prefillApplied]);

  const clientChange = async(cli_obj) => {
    if (cli_obj.value) {
      const filtered = allRequirements.filter(req => req.client_id == cli_obj.value);
      setRequirements(filtered);

      // Clear selected requirement if not found in filtered list
      if (
        fields.interview_requirement_id &&
        !filtered.some(req => req.value === fields.interview_requirement_id.value)
      ) {
        setFields(prev => ({ ...prev, interview_requirement_id: '' }));
      }
    } else {
      setRequirements([]); // or set to allRequirements if no client selected
    }
  };
  
  const finishSaveFlow = () => {
    if (isEdit) {
      navigate("/" + module.route);
    } else {
      setFields(inputFields);
    }
  };

  const closeStatusSuggestion = () => {
    setShowStatusSuggestion(false);
    setStatusSuggestion(null);
    if (pendingAfterSuggestion.current) {
      pendingAfterSuggestion.current();
      pendingAfterSuggestion.current = null;
    }
  };

  const maybeOfferStatusSuggestion = async (formData) => {
    if (isView) return false;

    const candidateId =
      formData.interview_candidate_id ||
      fields.interview_candidate_id?.value ||
      fields.interview_candidate_id;
    const interviewStatusId =
      formData.interview_status_id ||
      fields.interview_status_id?.value ||
      fields.interview_status_id;

    if (!candidateId || !interviewStatusId) return false;

    const interviewStatusLabel =
      fields.interview_status_id?.label ||
      interviewStatus.find(
        (opt) => String(opt.value) === String(interviewStatusId)
      )?.label ||
      "";

    const candidate = await findCandidateById(user_data.user_token, candidateId);
    if (!candidate) return false;

    const suggestion = resolveInterviewStatusSuggestion({
      interviewStatusLabel,
      candidate,
      statusOptions: candidateStatusOptions,
    });

    if (!suggestion) return false;

    setStatusSuggestion({ suggestion, candidate });
    setShowStatusSuggestion(true);
    pendingAfterSuggestion.current = finishSaveFlow;
    return true;
  };

  const submit = async(e) => {
    e.preventDefault();

    if (!isView) {
      const pipelineValidation = validatePipelineForm(fields, INTERVIEW_PIPELINE_RULES);
      if (!pipelineValidation.valid) {
        setErrors(pipelineValidation.errors);
        toast.error("Please fill all required fields.");
        return;
      }
    }
    
    // Start the loading state
    setLoading(true);

    try {
      // Clear previous errors
      setErrors({});

      const formData = formatDataBeforeSend(fields, inputFields, formatOptions);
      let response;
      if (data) {
        response = await model.update(user_data.user_token, id, formData);
      } else {
        response = await model.create(user_data.user_token, formData);
      }

      if (response.status) {
        setNotificationCount(localStorage.getItem('unread_notification_count'));
        toast.success(response.message);

        model.saveToStorage(response.data[module.key], response.data.pagination);

        const offeredSuggestion = await maybeOfferStatusSuggestion(formData);
        if (!offeredSuggestion) {
          finishSaveFlow();
        }
      } else {
        setErrors(response.error);
        toast.error(response.message);
      }
    } catch (error) {
      apiError(error);

      if (error.response?.data.invalid_token == 1) {
        navigate('/re-login');
      }
    }

    // Stop the loading state
    setLoading(false);
  }
  if (! module) {
    navigate('/interviews');
    return;
  }
  return (
    <AdminLayout>
      <Helmet>
        <title>{ isView ? 'View' : isEdit ? 'Edit' : 'Add'} {module.singularTitle} - Digital CMS</title>
      </Helmet>

      <div className="main-content app-content">
        <div className="container-fluid cms-form-shell">
          <PageHeader module={module} />

          {!isView && <WorkflowHelpBanner stage="interviews" />}

          <form onSubmit={submit}>
            <div className="row">
              <div className="col-sm-9">
                <div className="card custom-card">
                  <div className="card-header d-flex align-items-center justify-content-between flex-wrap gap-3">
                    <div className="card-title">{ isView ? 'View' : isEdit ? 'Edit' : 'Add'} {module.singularTitle}</div>
                  </div>
                  <div className="card-body">
                    <div className="row gy-2">
                      <div className="col-sm-4 mt-3">
                          <MyReactSelect options={candidates} column="interview_candidate_id" label="Candidate" required={true} fields={fields} setFields={setFields} errors={errors} disabled={isView} onChange={candidateChange} />
                          <HelpTooltip text="Select the candidate first — client and requirement are filled automatically from their active mapping." />
                      </div>
                      <div className="col-sm-4 mt-3">
                        <MyReactSelect options={clients} column="interview_client_id" label="Client" required={true} fields={fields} setFields={setFields} errors={errors} quickAddKey="clients" quickAddSet={setQuickModals} disabled={isView} onChange={clientChange} />
                      </div>
                      <div className="col-sm-4 mt-3">
                        <MyReactSelect options={requirements} column="interview_requirement_id" label="Requirement" required={true} fields={fields} setFields={setFields} errors={errors} disabled={isView} />
                      </div>
                      <div className="col-sm-4 mt-3">
                        <MyReactSelect options={rounds} column="interview_round_id" label="Round" required={true} fields={fields} setFields={setFields} errors={errors} disabled={isView} />
                      </div>
                      <div className="col-sm-4 mt-3">
                        <DatePicker column="interview_date" label="Date" required={true} fields={fields} setFields={setFields} errors={errors} disabled={isView} />
                      </div>
                      <div className="col-sm-4 mt-3">
                        <MyTimePicker column="interview_time" label="Time" required={true} fields={fields} setFields={setFields} errors={errors} disabled={isView} />
                      </div>
                      <div className="col-sm-4 mt-3">
                        <MySelect options={optionsModeOfInterviews} column="interview_mode" label="Mode" required={true} fields={fields} setFields={setFields} errors={errors} disabled={isView} firstOption="Select mode" />
                      </div>
                      <div className="col-sm-4 mt-3">
                        <MyReactSelect options={interviewStatus} column="interview_status_id" label="Status" required={true} fields={fields} setFields={setFields} errors={errors} disabled={isView} />
                      </div>
                      <div className="col-sm-4 mt-3">
                        <TextArea column="interview_remarks" label="Remarks" fields={fields} setFields={setFields} errors={errors} disabled={isView} />
                      </div>
                      <div className="col-sm-4 mt-3">
                        <label htmlFor="interview_no_show" className="form-label">
                          Mark as No Show
                        </label>
                        <div className="form-check form-switch large-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="interview_no_show"
                            checked={fields.interview_no_show === 1}
                            onChange={(e) =>
                              setFields((prev) => ({
                                ...prev,
                                interview_no_show: e.target.checked ? 1 : 0,
                              }))
                            }
                            disabled={isView}
                          />
                        </div>
                      </div>
                      {recruiterName && (
    <div className="col-sm-4 mt-3">
      <label className="fw-semibold mb-0 me-2">Recruiter:</label>
      <input type='text' value={recruiterName} readOnly className="form-control-plaintext text-muted d-inline-block" style={{ maxWidth: '200px' }} />
    </div>
  )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-sm-3">
                <div className="card custom-card">
                  <div className="card-header d-flex align-items-center justify-content-between flex-wrap gap-3">
                  {(isView && checkPermission(module.route, 'edit')) ? 
                    <a
                      className="btn btn-icon btn-sm btn-info"
                      title="Edit"
                      onClick={() => navigate(`/interviews/${data.interview_unique_id}/edit`,{ 
                        state: {
                          data: data,
                          module: module,
                        },
                      })} // Navigate to the edit page
                    >
                      <i className='bx bxs-edit'></i>
                    </a> : 
                    <div>
                      <button className="btn btn-primary btn-md" disabled={loading || (isNoShowFromData)} title={isNoShowFromData ? 'Cannot update when marked as No Show' : ''}>
                        {loading ? <span><span className="spinner-border spinner-border-sm align-middle"></span> Loading...</span> : 'Save'}
                      </button>
                    </div>}

                    <div className="d-flex flex-wrap gap-2">
                      <Link className="btn btn-light btn-sm float-end" to="/interviews">
                        <i className="bi bi-reply me-1 fw-semibold"></i> Back
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          {(data) ?
            <div className="row gy-2 mt-1">
              <div className="col-xl-12">
                <div className="card custom-card">
                  <div className="card-body">
                    <h5 className="card-title mb-3">
                      Pipeline links
                      <HelpTooltip text="Start onboarding with candidate and requirement details prefilled from this interview." />
                    </h5>
                    <div className="row gy-2 mb-3">
                      <div className="col-md-4">
                        {linkedOnboard ? (
                          <Link
                            to={`/onboards/${linkedOnboard.onboard_unique_id}/view`}
                            state={{
                              data: linkedOnboard,
                              module: {
                                title: "Onboards",
                                singularTitle: "Onboard",
                                key: "onboards",
                                route: "onboards",
                                primaryCol: "_onboard_id",
                              },
                            }}
                            className="btn w-100 btn-success mb-2"
                          >
                            View linked onboard
                          </Link>
                        ) : (
                          <button
                            type="button"
                            className="btn w-100 btn-primary mb-2"
                            onClick={() =>
                              navigate("/onboards/create", {
                                state: {
                                  module: {
                                    title: "Onboards",
                                    singularTitle: "Onboard",
                                    key: "onboards",
                                    route: "onboards",
                                    primaryCol: "_onboard_id",
                                  },
                                  prefill: {
                                    candidateId: data.interview_candidate_id,
                                    clientId: data.interview_client_id,
                                    requirementId: data.interview_requirement_id,
                                    interviewId: data._interview_id,
                                  },
                                },
                              })
                            }
                          >
                            Start onboard
                          </button>
                        )}
                        <Link
                          to={`/onboards/?_candidate_id=${data.interview_candidate_id}&_requirement_id=${data.interview_requirement_id}&_interview_id=${data._interview_id}`}
                          className="btn w-100 btn-light"
                        >
                          View onboards
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            : ''
          }
          </form>
        </div>
      </div>
      <QuickAdd title="Client" modalKey="clients" column="interview_client_id" setFieldOptions={setClients} showModal={quickModals.clients} form={quickAddClient} setShowModal={setQuickModals} fields={fields} setFields={setFields} />
      <StatusSuggestionModal
        show={showStatusSuggestion}
        onHide={closeStatusSuggestion}
        suggestion={statusSuggestion?.suggestion}
        candidate={statusSuggestion?.candidate}
        userToken={user_data.user_token}
      />
      <Helmet></Helmet>
    </AdminLayout>
  );
};